import {
  Accordion,
  AccordionSummary,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'
import { useContext, useState } from 'react'
import { BiChevronDown } from 'react-icons/bi'
import { useNavigate } from 'react-router-dom'
import { GlobalContext } from '../App'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: {
    flexShrink: 0,
    whiteSpace: 'nowrap',
    background: '#e7e8e8',
    paddingTop: 75,
    minHeight: 'calc(100vh - 64px)',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  drawerOpen: {
    width: () => 240,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: 0,
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
  titulo: {
    flex: '1 0',
    margin: '0 10px',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  icon: {
    fontSize: '1.5rem',
  },
}))

const Menu = () => {
  const { menuWidth, menuOpen, programas } = useContext(GlobalContext)
  const classes = useStyles(menuWidth)

  const history = useNavigate()

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const redirect = (link) => (_e) => history(link)

  const [expanded, setExpanded] = useState('')

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  return (
    <div
      open={menuOpen}
      className={clsx(classes.drawer, {
        [classes.drawerOpen]: menuOpen,
        [classes.drawerClose]: !menuOpen,
      })}
    >
      {programas?.map((programa, i) => (
        <Accordion
          key={i}
          TransitionProps={{
            timeout: 400,
          }}
          style={{
            margin: 5,
            marginLeft: 20,
            borderRadius: 15,
            minHeight: 0,
            overflow: 'hidden',
            backgroundColor: expanded === i ? '#629988' : '#59a68d',
            boxShadow: 'none',
            '&.Mui-expanded': {
              margin: '5px 0 5px 20px',
              borderRadius: 15,
            },
          }}
          expanded={expanded === i}
          onChange={handleChange(i)}
        >
          <AccordionSummary
            key={i}
            expandIcon={
              <BiChevronDown style={{ color: 'white', lineHeight: 1.0 }} />
            }
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={{
              boxShadow: 'none',
              border: 'none',
            }}
          >
            <div
              style={{
                width: '100%',
                textTransform: 'uppercase',
                paddingRight: 8,
                paddingTop: 0,
                color: 'white',
              }}
            >
              <span style={{ fontSize: 12 }}>{programa[0][1]}</span>
            </div>
          </AccordionSummary>
          {programa[1].map((filhos) => (
            <ListItem
              style={{
                backgroundColor: '#dedede',
                lineHeight: 1.0,
                fontWeight: 300,
              }}
              button
              key={filhos[0]}
              onClick={redirect(filhos[3])}
            >
              <ListItemIcon
                style={{ minWidth: 25, lineHeight: 1.0, color: '#5c5c5c' }}
                className={classes.icon}
              >
                <i className={filhos[4]} style={{ fontSize: 12 }} />
              </ListItemIcon>
              <ListItemText>
                <span
                  style={{
                    color: 'black',
                    fontSize: '0.90rem',
                    fontWeight: 300,
                  }}
                >
                  {filhos[1]}
                </span>
              </ListItemText>
            </ListItem>
          ))}
        </Accordion>
      ))}
    </div>
  )
}

export default Menu
